module.exports = __webpack_public_path__ + "media/images/icons/heart-cd567705741b34b8e5d51a21891cc760.svg";